<template>
  <div>
    <vx-modal nameClass="Component_actions" :title="$t(`MODALS.actions.listQuestions`)" width="30%">
      <template v-slot:body>
        <div class="absoluted top-0d flex justify-center">
          <div class="w-full bg-white rounded-lg2 border">
            <div class="border border-t-0 border-l-0 border-r-0 flex items-center pxs-2 pys-2">
              <i class="material-icons p-0 m-0 bg-successf"> search </i>
              <input
                v-model.trim="search"
                class="w-full border-0 rounded-lg h-8 px-2"
                type="text"
                :placeholder="$t(`MODALS.actions.search`)"
              />
            </div>
            <div class="px-1 py-3 overflow-auto" style="height: 250px">
              <div class="flex items-start border border-t-0 border-l-0 border-r-0 py-2 px-2 last-item">
                <vs-checkbox @change="allSelect($event)">All</vs-checkbox>
              </div>
              <div
                class="flex items-start border border-t-0 border-l-0 border-r-0 py-2 px-2 last-item"
                v-for="(question, j) in searchQuestions"
                :key="j"
              >
                <vs-checkbox v-model="data" :vs-value="question"></vs-checkbox>
                <div class="flex flex-col w-full">
                  <div class="flex justify-between">
                    <span class="font-bold">{{ question.name }}</span>
                    <span>{{ $t(`INPUTTYPE.${question.type}.${question.inputType}`) }}</span>
                  </div>
                  <span>{{ question.label }}</span>
                </div>
              </div>
            </div>
            <div class="flex justify-end py-2 border border-t border-l-0 border-r-0 border-b-0">
              <vs-button color="danger" type="border" @click="closedModal">{{ $t(`MODALS.actions.cancel`) }}</vs-button>
              <vs-button class="ml-3 mr-3" color="success" type="border" @click="sendData">{{
                $t(`MODALS.actions.ToAccept`)
              }}</vs-button>
            </div>
          </div>
        </div>
      </template>
    </vx-modal>
  </div>
</template>

<script>
import { getAllQuestion } from "@/serviforms/designer/indexDB/logic.js";
import { mapState, mapMutations } from "vuex";

export default {
  data: () => ({
    allQuestions: [],
    data: [],
    search: ""
  }),
  async mounted() {
    const result = await getAllQuestion();
    this.allQuestions = result;
  },
  computed: {
    ...mapState("resource", ["questionsByPage", "indexQuestion"]),
    /**
     * Obtiene la posición de la pregunta denhtro de la lista de preguntas del formularios.
     */
    getIndexQuestion() {
      return this.allQuestions.findIndex(question => question.name === this.questionsByPage[this.indexQuestion].name);
    },
    /**
     * Obtiene la lista de preguntas desde la pregunta padre hacia arriba.
     */
    getQuestionsUp() {
      return this.allQuestions.slice(0, this.getIndexQuestion);
    },
    /**
     * Filtra las pregunta por el subtipo de pregunta, por mlo geneneral aquellas con las que se pueden operar dentro de una acción.
     */
    filterQuestions() {
      return this.getQuestionsUp
        .map((question, index) => ({
          name: question.name,
          position: index,
          label: question.label,
          type: question.type,
          inputType: question.inputType
        }))
        .filter(
          question =>
            question.inputType === "number" ||
            question.inputType === "currency" ||
            question.inputType === "default" ||
            question.inputType === "action"
        );
    },
    ArrayNames() {
      return this.questionsByPage[this.indexQuestion].actions.questions.map(question => question.name);
    },
    questions() {
      return this.filterQuestions.filter(question => !this.ArrayNames.includes(question.name));
    },
    searchQuestions() {
      return this.questions.filter(question => {
        if (this.search.length > 0) {
          const condition1 = question.name.toLowerCase().includes(this.search.toLowerCase());
          const condition2 = question.label.toLowerCase().includes(this.search.toLowerCase());
          return condition1 || condition2;
        }
        return true;
      });
    }
  },
  methods: {
    ...mapMutations("resource", ["UPDATE_STATE"]),
    closedModal() {
      this.UPDATE_STATE({ key: "activePopup", value: false });
      setTimeout(() => {
        this.UPDATE_STATE({ key: "componentPopup", value: "" });
      }, 50);
    },
    sendData() {
      if (this.data.length > 0) {
        const getData = this.data.map(question => ({
          name: question.name,
          position: question.position,
          type: question.type === "subform" ? "subform" : "standard"
        }));
        this.questionsByPage[this.indexQuestion].actions.questions = [
          ...this.questionsByPage[this.indexQuestion].actions.questions,
          ...getData
        ];
      }
      this.closedModal();
    },
    allSelect(event) {
      if (event.target.checked) {
        return (this.data = this.searchQuestions);
      }
      this.data = [];
    },
  }
};
</script>

<style lang="scss" scoped></style>
